import getListing from './get-listing.api';
import create from './create.api';

const partnersAndResellersApi = {
  getListing,
  create,
};

export default partnersAndResellersApi;
